import { useEffect } from "react";

// Production canonical origin. Update if the primary domain changes.
const ORIGIN = "https://queencleopatra.co.uk";
const DEFAULT_IMAGE =
  "https://customer-assets.emergentagent.com/job_trance-bookings/artifacts/ibi954ka_london%20uk%20erotic%20hypnotist.jpg";

function setMetaTag(attr, name, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

// One hook to configure per-page SEO. Call at the top of every page component.
// Everything is optional; sensible fallbacks apply.
export default function usePageMeta({
  title,
  description,
  path = "",
  image,
  jsonLd,
  jsonLdId = "page-jsonld",
} = {}) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} · UK Queen of Erotic Hypnosis`
      : "Queen Cleopatra · UK Queen of Erotic Hypnosis";
    const desc =
      description ||
      "London-based British erotic hypnotist with a crisp English accent. In-person erotic hypnosis and consensual fly-on-the-wall session videos. Adults 18+.";
    const url = `${ORIGIN}${path || "/"}`;
    const img = image || DEFAULT_IMAGE;

    document.title = fullTitle;
    setMetaTag("name", "description", desc);
    setCanonical(url);

    setMetaTag("property", "og:title", fullTitle);
    setMetaTag("property", "og:description", desc);
    setMetaTag("property", "og:url", url);
    setMetaTag("property", "og:image", img);

    setMetaTag("name", "twitter:title", fullTitle);
    setMetaTag("name", "twitter:description", desc);
    setMetaTag("name", "twitter:image", img);

    if (jsonLd) {
      upsertJsonLd(jsonLdId, jsonLd);
    }

    // Clean up per-page JSON-LD when leaving the route
    return () => {
      if (jsonLd) {
        const el = document.getElementById(jsonLdId);
        if (el) el.remove();
      }
    };
  }, [title, description, path, image, jsonLd, jsonLdId]);
}
